export default (url: string | URL) => {
    const urlString = typeof url === 'object' ? url.toString() : url;
    return urlString
        .replace('https:', '')
        .replace('http:', '')
        .replace(/^\/\//, 'https://');
};
